/* eslint-disable prefer-rest-params */
import { GlobalState } from '@leverege/ui-redux';
import OverridesReducer from "./OverridesReducer.js";
import UserResourcesStore from "./UserResourcesStore.js"; // Singleton
export default class ReduxOverrides {
  /**
   * 
   * @param {String|Array<String>} path The general group name of overrides. The path
   * is usually the path to a particular screen. All overrides with the screen are grouped
   * together. This will be used in the get/set requests so the data viewers/uses do not
   * have to supply them. 
   */
  constructor(path, opts) {
    this.path = path;
    this.backingStore = opts?.backingStore || UserResourcesStore;
    this.state = opts?.state || {};
    this.dispatch = opts?.dispatch || GlobalState.dispatch;
  }

  /**
   * Returns the value of the overrides for the given id or id/key. 
   * @param {String} id The Id of the override to get
   * @param {String} [key] The option path to the value to return. If not supplied, 
   * the entire overrides for the id is returned
   */
  get(id, key) {
    // Using getOverrides as this.state is the overrides state
    return OverridesReducer.getOverrides(this.state, this.path, id, key);
  }

  /**
   * Set the value of the overrides for the given id or id/key. 
   * @param {String} id The Id of the override to get
   * @param {String} [key] The option path to the value to return. If not supplied, 
   * the entire overrides for the id is returned
   * @param {any} value the value to set. 
   * @returns the result of dispatch
   */
  set(id, key, value) {
    const len = arguments.length;
    const hasKey = len === 3;
    const rKey = hasKey ? key : null;
    const rValue = hasKey ? value : key;
    const action = {
      type: 'molten.dataViewers.SetOverrides',
      path: this.path,
      id,
      key: rKey,
      value: rValue
    };
    if (this.backingStore) {
      this.backingStore.set(this.path, id, rKey, rValue);
    }
    return this.dispatch(action);
  }

  /**
   * Call this when the state has changed. This will return either itself or
   * a new version to use.
   * @param {Object} state The overrides object from the redux state 
   * @param {String||Array<String>} [path] the path of the override controller
   * @returns {ReduxOverrides} either a new overrides object, or this.
   */
  update(state, path) {
    if (state !== this.state || path && this.path !== path) {
      return new ReduxOverrides(path || this.path, {
        state,
        backingStore: this.backingStore,
        dispatch: this.dispatch
      });
    }
    return this;
  }
}